import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse} from '@angular/common/http';
import {catchError, Observable, throwError} from 'rxjs';
import {LocalStorageService} from './local-storage.service';
import {AuthenticationService} from './authentication.service';
import {Router} from '@angular/router';
import {EMAIL_UNCONFIRMED} from '../../views/string-constants';


@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private storageService: LocalStorageService,
              private authService: AuthenticationService,
              private router: Router,
              @Inject(PLATFORM_ID) private platformId: Object) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = this.storageService.getItem('token');

    let headers = req.headers;
    if (token) {
      headers = headers.append('Authorization', `Bearer ${token}`);
    }

    const authReq = req.clone({ headers });
    return next.handle(authReq).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          const isLoginRequest = req.url.includes('/login');
          // Only logout if it's NOT a login page error (email unconfirmed or bad credentials)
          if (!isLoginRequest) {
            this.authService.logout();
          }
        }
        return throwError(error);
      })
    );
  }
}
